<template>
  <div>
    <PageHeaderBanner>
      <template #title>
        <span>マスタメンテナンス</span>
      </template>
    </PageHeaderBanner>
    <MasterMaintenanceMenuList mode="tile" style="width: 80%; margin: 0 auto" />
  </div>
</template>
<script setup lang="ts">
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MasterMaintenanceMenuList from '../../components/list/MasterMaintenanceMenuList.vue';

const emit = defineEmits<{
  (event: 'closeDrawer'): void;
}>();
// 初期表示時にサイドバーを閉じる
emit('closeDrawer');
</script>
